import React from 'react';
import PropTypes from 'prop-types';
import Dimmer from '../../../../components/Dimmer/Dimmer';
import LoaderLabelled from '../../../../components/LoaderLabelled/LoaderLabelled';

const PlayByPlayAccordionFeedback = ({ isLoading, hasError, playsData }) => {
  const feedbackContent = () => {
    if (isLoading) {
      return <LoaderLabelled text="Loading" />;
    }
    if (hasError) {
      return <p>There was an error loading the data</p>;
    }
    if (!playsData || playsData?.length === 0) {
      return <p>No Data available</p>;
    }
    return null;
  };

  return (
    feedbackContent() && (
      <div>
        <Dimmer>{feedbackContent()}</Dimmer>
      </div>
    )
  );
};

PlayByPlayAccordionFeedback.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  playsData: PropTypes.arrayOf(
    PropTypes.shape({
      game: PropTypes.shape({
        awayTeam: PropTypes.shape({ name: PropTypes.string }),
        homeTeam: PropTypes.shape({ name: PropTypes.string }),
      }),
    })
  ),
};

PlayByPlayAccordionFeedback.defaultProps = {
  playsData: undefined,
};

export default PlayByPlayAccordionFeedback;
